import React, { memo } from 'react';
import * as motion from 'motion/react-client';
import { AnimatePresence } from 'motion/react';

import { useStyles } from './styles';
import { STYLE } from 'constants/style';

export interface ITabsProps {
  tabs: { value: string; label: string; content: any; tabProps?: any }[];
  selectedTab: { value: string; label: string };
  tabsParentStyleClass?: string;
  tabsContainerStyleClass?: string;
  onChange: (selectedTab: { value: string; label: string }) => void;
}

const Tabs = ({ tabs, selectedTab, tabsContainerStyleClass, tabsParentStyleClass, onChange }: ITabsProps) => {
  const classes = useStyles();
  return (
    <div className={`${classes.tabsParent} ${tabsParentStyleClass || ''}`}>
      <div className={`${classes.tabsContainer} ${tabsContainerStyleClass || ''}`}>
        {tabs.map(tab => (
          <div
            key={tab.value || tab.label}
            className={classes.tab}
            onClick={() => onChange({ value: tab.value, label: tab.label })}
            {...tab.tabProps}
          >
            {selectedTab.value === tab.value && (
              <motion.div className={classes.animatingDiv} layoutId="bubble" id="bubble" />
            )}
            <motion.span
              initial={false}
              animate={{
                color: selectedTab.value === tab.value ? STYLE.COLOR.WHITE : STYLE.COLOR.ACCENT_PRIMARY,
              }}
              className={classes.tabLabel}
            >
              {tab.label}
            </motion.span>
          </div>
        ))}
      </div>
      <AnimatePresence initial={false} mode="wait">
        <motion.div
          key={selectedTab.value || 'empty'}
          variants={{
            initial: { y: 10, opacity: 0 },
            enter: { y: 0, opacity: 1 },
            exit: { y: -10, opacity: 0 },
          }}
          initial="initial"
          animate="enter"
          exit="exit"
          transition={{
            duration: 0.3,
          }}
        >
          {tabs.find(tab => tab.value === selectedTab.value)?.content || null}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default memo(Tabs);
